import React, {useEffect, useState} from "react";
import { Image } from "@arctheme-components/elements/Image/Image";
import useVideoSource from "@arctheme-hooks/useVideoSourceQuality";

const MediaArea = ({ globals, settings, isMobile }) => {
    const layout = isMobile ? settings.layout_type : settings.layout_type_mobile;
    const image = isMobile ? settings.image_mobile : settings.image;
    const [videoSources, setVideoSources]: any = useState([]);

    // Pre-process the video sources using the hook
    const videoSettings = isMobile
        ? settings?.video_mobile
        : settings?.video;

    const videoSourcesToCheck = videoSettings?.sources;

    const offsetTop = isMobile ? settings.media_offset_top_mobile || -16 : settings.media_offset_top || -24;
    const offsetLeft = isMobile ? settings.media_offset_left_mobile || -16 : settings.media_offset_left || -24;
    const bgWidth = isMobile ? settings.media_bg_width_mobile || 100 : settings.media_bg_width || 100;
    const bgHeight = isMobile ? settings.media_bg_height_mobile || 100 : settings.media_bg_height || 100;
    const borderRadius = settings.media_bg_radius || 32;
    const bgColor = settings.media_bg_color || '#F2610D';
    const showBg = settings.media_show_background;
    
    const offsetStyle = {
      top: `${offsetTop}px`,
      left: `${offsetLeft}px`,
      width: `${bgWidth}%`,  
      height: `${bgHeight}%`, 
      backgroundColor: bgColor,
      borderRadius: `${borderRadius}px`,
    };
    

    // Call the hook to get video URL and poster for each video block
    let processedVideos: any = null;
    let videoUrl: any = null;
    let videoPoster: any = null;
    if (videoSourcesToCheck) {
        const {videoUrl, videoPoster} = useVideoSource(
            videoSourcesToCheck,
            videoSettings?.preview_image,
            isMobile,
            globals.video_quality
        );

        processedVideos = {videoUrl, videoPoster};
    }

    useEffect(() => {
        if (processedVideos) {
            setVideoSources(processedVideos);
        }
    }, []); // useEffect will trigger when processedVideos changes

    return (
        <div className={`twi-${layout}__media overflow-visible ${ showBg ? `pt-[${-offsetTop}px] pl-[${-offsetLeft}px]` : ''}`}>
            {image ? (
            <div className="relative inline-block w-full">
                {showBg && <div className="absolute z-0" style={offsetStyle} aria-hidden="true" />}
                <Image imageUrl={image} classes="relative z-10 object-cover h-full w-full rounded-[32px]" />
            </div>
            ) : videoSources.videoUrl ? (
            <div className="relative inline-block rounded-[32px]">
                {showBg && <div className="absolute z-0" style={offsetStyle} aria-hidden="true" />}
                <video
                className="relative z-10 object-cover h-full w-full"
                autoPlay
                loop
                muted
                poster={videoSources.videoPoster}
                preload="metadata"
                playsInline
                >
                <source src={videoSources.videoUrl} type="video/mp4" />
                </video>
            </div>
            ) : null}
        </div>
      );
};

export default MediaArea;
